import { gql } from "@apollo/client";

export const GET_CURRENT_USER_WALLET = gql`
  query GetCurrentUserWallet {
    getCurrentUserWallet {
      id
      point
      balance
      isActive
      isLocked
      systemUserId
      systemUser {
        package
      }
    }
  }
`;

export const REQUEST_WALLET_TRANSFER = gql`
  mutation RequestWalletTransfer($input: WalletTransferInput!) {
    requestWalletTransfer(input: $input) {
      success
      message
      wallet {
        id
        point
      }
    }
  }
`;

export const GET_ALL_WALLET_APPROVALS = gql`
  query GetAllWalletApprovals {
    getAllWalletApprovals {
      walletApprovals {
        id
        amount
        status
        type
        description
        createdAt
        fromWallet {
          id
          systemUser {
            name
            package
          }
        }
        toWallet {
          id
          systemUser {
            name
            package
          }
        }
      }
    }
  }
`;

export const APPROVE_WALLET_TRANSFER = gql`
  mutation ApproveWalletTransfer($id: String!, $approved: Boolean!) {
    approveWalletTransfer(id: $id, approved: $approved) {
      success
      message
    }
  }
`;

export const GET_PENDING_POINT = gql`
  query GetPendingPoint {
    getPendingPoint
  }
`;

export const CHECK_USER_EXISTS = gql`
  query CheckUserExists($userName: String!) {
    checkUserExists(userName: $userName)
  }
`;

export const GET_WITHDRAWAL_HISTORY = gql`
  query GetWithdrawalHistory {
    getWithdrawalHistory {
      walletTransactions {
        id
        amount
        status
        type
        description
        referralLevel
        referredUserId
        balanceAfter
        createdAt
        fromWallet {
          id
          systemUser {
            name
            package
          }
        }
        toWallet {
          id
          systemUser {
            name
            package
          }
        }
      }
    }
  }
`;

export const GET_TOTAL_WITHDRAWAL = gql`
  query GetTotalWithdrawal {
    getTotalWithdrawal
  }
`;

export const GET_TOTAL_POINTS_TRANSFERRED = gql`
  query GetTotalPointsTransferred {
    getTotalPointsTransferred
  }
`;

export const GET_TOTAL_INCENTIVE_POINTS = gql`
  query GetTotalIncentivePoints {
    getTotalIncentivePoints
  }
`;

export const REQUEST_WALLET_TOPUP = gql`
  mutation TopupUserWallet($input: WalletTopupInput!) {
    topupUserWallet(input: $input) {
      success
      message
      wallet {
        id
        point
        balance
      }
    }
  }
`;

export const GET_CURRENT_USER_AVAILABLE_BALANCE = gql`
  query GetCurrentUserAvailableBalance {
    getCurrentUserAvailableBalance
  }
`;

export const GET_REFERRAL_BONUS_HISTORY = gql`
  query GetReferralBonusHistory {
    getReferralBonusHistory {
      success
      message
      walletTransactions {
        id
        amount
        status
        type
        description
        referralLevel
        referredUserId
        balanceAfter
        createdAt
        fromWallet {
          id
          systemUser {
            name
            package
          }
        }
        toWallet {
          id
          systemUser {
            name
            package
          }
        }
      }
    }
  }
`;